export default __webpack_public_path__ + "static/media/purchase-icon.d172e68b.svg";